import { useFloorPlanData } from "../../FloorPlanModal/hooks/useFloorPlanData";
import { useSymbols } from "../../FloorPlanModal/hooks/useSymbols";
import { useLiveData } from "./useLiveData";
import { useLiveEquipment } from "./useLiveEquipment";
import { useLiveTripwires } from "./useLiveTripwires";

/**
 * Everything a live site canvas draws, fetched once per host: the floor plan,
 * symbols, live personnel/stations/alerts/stats, machines and tripwires.
 * The live dashboard calls it once and feeds its canvas AND its other panels
 * (personnel list, stats with the 即時/pause toggle, alerts); the 即時定位
 * widget calls it itself, so it needs nothing but a machineID.
 */
export const useLiveSiteData = (machineID, { isPaused = false } = {}) => {
  const floorPlan = useFloorPlanData(machineID, true);
  const { placedSymbols } = useSymbols(machineID, true);
  const live = useLiveData(machineID, true, isPaused, floorPlan.loading);
  const { equipment } = useLiveEquipment(machineID, true, isPaused);
  const { tripwires } = useLiveTripwires(machineID, true);
  return { ...live, floorPlan, placedSymbols, equipment, tripwires };
};

export const isOnDuty = (person) => person.onDuty === 1 || person.onDuty === true;

export default useLiveSiteData;
